module.exports = __webpack_public_path__ + "media/packs/images/flags/SV-792c9b94b51ef2830eb39c4d0d54d646.svg";